import { View } from "react-native";
import Tile from "./Tile";
import { TilesListProps } from "./TilesList.type";
import styles from "./TilesList.styles"

export default function TilesList({tiles, onPress} : TilesListProps) {
    return (
        <View style={styles.tileList}>
            {tiles.map((tile) => (<Tile key={tile.id} tile={tile} onPress={onPress} />))}
        </View>
    )
}
